import React, {useContext} from "react";
import FormatUtils from "../../../utils/FormatUtils";
import {CustomerTypeContext, isCustomerCompany} from "../../../context/customer-type-context";

function InstallmentSubmitBox(props) {

    const customerContext = useContext(CustomerTypeContext);

    let taxType = props.isCreditCalculation ? "brutto" : isCustomerCompany(customerContext) ? "netto" : "brutto";
    let totalInstallment = FormatUtils.formatMoney(
        isCustomerCompany(customerContext) ? props.installment.net : props.installment.gross
    );

    // Shrink the amount on mobile when it has many digits so it stays on one line.
    let digitCount = (totalInstallment.match(/\d/g) || []).length;
    let amountClass = "calc__rata-amount" + (digitCount >= 5 ? " calc__rata-amount--long" : "");
    // Split off the currency so "zł" can be styled separately (not bold on mobile).
    let amountNumber = totalInstallment.replace(/\s*zł\s*$/i, '');

    return (
        <div className="calc__submit">
            <div className="calc__rata-box">
                <span className="calc__rata-label">Rata razem</span>
                <div className="calc__rata-value">
                    <span className={amountClass}>{amountNumber}<span className="calc__rata-currency">&nbsp;zł</span></span>
                    <span className="calc__rata-unit">{taxType} / miesiąc</span>
                </div>
            </div>
            <div className="calc__cta-row">
                <button type="button" className="calc__btn calc__btn--contact" onClick={props.onSendMessageClick}>
                    Skontaktuj się
                </button>
                <button type="button" className="calc__btn calc__btn--reserve" onClick={props.onReservationClick}>
                    Złóż wniosek
                </button>
            </div>
        </div>
    );
}

export default InstallmentSubmitBox;
